import type { RouteRecordRaw } from 'vue-router';

export const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: 'notifications',
    name: 'notifications',
    component: () => import('./pages/NotificationsListPage.vue'),
    meta: { title: 'Notifications', requiresAuth: true },
  },
  {
    path: 'notifications/:id',
    name: 'notifications.show',
    component: () => import('./pages/NotificationDetailPage.vue'),
    meta: { title: 'Notification', requiresAuth: true },
  },
];
